module.exports = __webpack_public_path__ + "img/round-user.9b8030fe.png";